<ion-card
  class="info-tile"
  button
  [routerLink]="info.redirectLink"
  *ngIf="!p.renderMobile"
>
  <ion-item class="info-tile__header" lines="none">
    <p class="info-tile__title">
      {{ info.titleTranslation | translate }}
    </p>

    <ion-icon
      slot="end"
      class="icon"
      [name]="info.iconname ? info.iconname : ''"
      [src]="info.icon ? info.icon : ''"
      size="large"
    ></ion-icon>
  </ion-item>
  <ion-item class="info-tile__header" lines="none">
    <ion-text class="info-tile__counter">
      <app-loading *ngIf="!info.count() && info.count() !== 0"> </app-loading>
      <ng-container *ngIf="info.count() || info.count() === 0">
        {{ info.count() }}
      </ng-container>
    </ion-text>
  </ion-item>
</ion-card>

<div class="info-tile__link-container" *ngIf="!p.renderMobile">
  <div class="info-tile__separator"></div>
  <div class="info-tile__add-link-container">
    <ng-container *ngIf="info.addEndpoint">
      <a
        class="info-tile__add-link"
        [routerLink]="info.addEndpoint"
        *appHasRole="[info.addRole]"
        [queryParams]="{ section: info.addEndpointQueryParam }"
      >
        <ion-icon size="small" name="add-outline"></ion-icon>
        {{ info.addLinkTitleTranslationDesktop | translate }}
      </a>
    </ng-container>
  </div>
</div>

<ion-card
  *ngIf="p.renderMobile"
  class="info-tile__mobile-container"
  button
  [routerLink]="info.redirectLink"
>
  <div class="info-tile__mobile-container-inner">
    <ion-item lines="none" class="info-tile__mobile-icon-container">
      <ion-badge
        *ngIf="info.count() !== '0' && info.count() !== 0"
        color="danger"
        slot="start"
        class="info-tile__mobile-counter"
        >{{ info.count() }}</ion-badge
      >
      <ion-icon
        slot="start"
        class="info-tile__mobile-icon"
        [name]="info.iconname ? info.iconname : ''"
        [src]="info.icon ? info.icon : ''"
        size="small"
      >
      </ion-icon>
    </ion-item>
    <ion-text color="primary">
      <h2 class="info-tile__mobile-title">
        {{ info.titleTranslation | translate }}
      </h2>
    </ion-text>
    <!-- <ng-container *appHasRole="[info.addRole]">
      <div class="info-tile__mobile-button-container" *ngIf="info.addEndpoint">
        <ion-button
          shape="round"
          (click)="onAddElement($event, info.addEndpoint)"
          class="info-tile__mobile-button"
        >
          <ion-icon slot="start" name="add"></ion-icon>
          {{ "ADD" | translate }}
        </ion-button>
      </div>
    </ng-container> -->
  </div>
</ion-card>
